(function () {
  "use strict";

  FreeContentSidebarCtrl.$inject = ['$scope', 'freeContentResource', 'trackingService', 'homeResource', '$location', '$rootScope'];
  angular
    .module('trainerWebApp.controllers')
    .controller('FreeContentSidebarCtrl', FreeContentSidebarCtrl);

  function FreeContentSidebarCtrl($scope, freeContentResource, trackingService, homeResource, $location, $rootScope) {

    $scope.viewModel = {
      freeCourses: [],
      hasFreeCourses: false,
      hasFreeTemplates: false
    };

    var templateUrl = "";

    freeContentResource.load(function (res) {
      initData(res);
    });

    function initData(data) {
      $scope.viewModel.freeCourses = data.courses || [];
      $scope.viewModel.hasFreeCourses = $scope.viewModel.freeCourses.length > 0;
      $scope.viewModel.hasFreeTemplates = !!data.templateUrl;
      templateUrl = data.templateUrl;
    }

    $scope.downloadTemplate = function (color) {
      trackingService.trackKissMetricsEvent("download template", {
        color: color
      });
    };

    $scope.addFreeCourse = function (courseId) {

      var course = _.find($scope.viewModel.freeCourses, function (item) {
        return item.id == courseId
      });

      if (!course) {
        return;
      }

      $rootScope.$broadcast('$showLoadingSpinner', true);

      homeResource.copyFreeCourse(courseId, function (res) {
        trackingService.trackKissMetricsEvent("added course", {
          courseId: courseId,
          name: course.name
        });


        $rootScope.$broadcast('$showLoadingSpinner', false);
        $location.path('/TMS/Course_Dashboard/' + res.courseId);

      });


      return false;
    };

    $scope.getDownloadTemplateUrl = function (color) {
      if (!templateUrl) {
        return "#";
      }
      return templateUrl.replace("{color}", color);
    }
  }

})();
